export enum Carrier {
    NO_CONNECTION = -1,
    OTHER_THAN_LISTED = 0,
    TELEKOM = 1,
}
